module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel02_770_280_th-275b78da93940bab2313c06897e5804d.jpg";